<template>
  <el-empty>
    <template #image>
      <img src="@/assets/no_content.svg" alt="img">
    </template>

    <template #description>
      <div class="quests__header">
        <h1 class="quests__title">
          {{ title }}
        </h1>
      </div>
    </template>
  </el-empty>
</template>

<script>
export default {
  name: 'AppEmpty',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
